import React from 'react';
import './ProBadge.css';

/**
 * Reusable PRO badge with animated shimmer effect.
 * @param {'mini' | 'default' | 'hero'} size - Badge size variant
 * @param {string} label - Override default label text
 */
export default function ProBadge({ size = 'default', label }) {
  const text = label || (size === 'hero' ? '✦ PRO Member' : '✦ PRO');

  return (
    <span className={`pro-badge pro-badge--${size}`} title="Learnlia PRO member">
      {text}
    </span>
  );
}
